export default {
      id: "ic-para-info-usage",
      viewBox: "0 0 26 26",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-para-info-usage",
      toString: function () {
        return this.url;
      }
    }